// import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DeliveryDateButton from "../components/DeliveryDateButton";
// import CheckoutContext from "../contexts/CheckoutContext";
// import ProductsResume from "../components/ProductsResume";
// import LoadingSpinner from "../components/LoadingSpinner";




// const DayForm = () => {
//     const navigate = useNavigate();


//     const [instances, setInstances] = useState([]);
//     const [isLoaded, setIsLoaded] = useState(false);
//     const [dayClicked, setDayClicked] = useState(null);

//     const { items, setDeliveryDate, deliveryDate } = useContext(CheckoutContext);

//     useEffect(() => {
//         if (items.length === 0) {
//             navigate("/");
//         } else {
//             setDayClicked(deliveryDate[0]);
//         }
//     } ,[]);

//     useEffect(() => {
//         async function getInstances() {
//             try {
//                 const response = await axios.get(`${process.env.REACT_APP_API_URL}instance/active`);
//                 setInstances(response.data);
//                 setIsLoaded(true)
//             } catch (error) {
//                 console.log(error);
//             }
//         }
//         getInstances();
//     }, []);

//     function handleClickInstance (event) {
//         event.preventDefault();
//         setDeliveryDate(
//             [
//                 event.currentTarget.id,
//                 event.currentTarget.attributes.dayname.value,
//                 event.currentTarget.attributes.daynumber.value,
//                 event.currentTarget.attributes.monthname.value
//             ]
//         );
//         setDayClicked(event.currentTarget.id);
//     }

//     function handleClickContinue (event) {
//         event.preventDefault();
//         navigate(`/client`);
//     }


//     if (isLoaded) {
//         return (
//             <div>
//                 <div className="mt-4">
//                     <div>
//                         <ProductsResume items={items}/>
//                     </div>
//                 </div>
//                 <div className="mt-4">

//                 </div>
//                 <div className="text-center text-2xl text-gray-600 mb-6 font-bold">
//                     <p>Selecciona día de despacho</p>
//                 </div>

//                 <div className="flex justify-center justify-around font-bold text-gray-600">
//                     {instances.map((instance) => 
//                         <div onClick={handleClickInstance} id={instance.id} key={instance.id} dayname={instance.dayName} daynumber={instance.dayNumber} monthname={instance.monthName}
//                             className={"border-2 border-gray-200 shadow-xl m-2" + (dayClicked == instance.id ? " bg-blue-400" : "")} style={{width: "100px"}}>
//                             <DeliveryDateButton instance={instance} />
//                         </div>
//                     )}
//                 </div>
//                 <div className="h-10 mx-8 text-white font-bold mt-10">
//                     <button onClick={handleClickContinue} className="bg-gray-700 hover:bg-gray-900 disabled:bg-gray-300 h-full w-full" disabled={deliveryDate.length === 0}>Continuar</button>
//                 </div>
//             </div>
//         );
//     } else {
//         return(
//             <div className="mt-72">
//                 <LoadingSpinner/>
//             </div>
//         );
//     }
    
// }

// export default DayForm;


import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DeliveryDateButton from "../components/DeliveryDateButton";
import CheckoutContext from "../contexts/CheckoutContext";
import ProductsResume from "../components/ProductsResume";
import LoadingSpinner from "../components/LoadingSpinner";
import MainTitle from "../components/MainTitle";

const DayForm = () => {
    const navigate = useNavigate();

    const [instances, setInstances] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [dayClicked, setDayClicked] = useState(null);

    const { items, setDeliveryDate, deliveryDate } = useContext(CheckoutContext);

    useEffect(() => {
        if (items.length === 0) {
            navigate("/");
        } else {
            setDayClicked(deliveryDate[0]);
        }
    }, []);

    useEffect(() => {
        async function getInstances() {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}instance/active`);
                setInstances(response.data);
                setIsLoaded(true);
            } catch (error) {
                console.log(error);
            }
        }
        getInstances();
    }, []);

    function handleClickInstance(event) {
        event.preventDefault();
        setDeliveryDate([
            event.currentTarget.id,
            event.currentTarget.attributes.dayname.value,
            event.currentTarget.attributes.daynumber.value,
            event.currentTarget.attributes.monthname.value,
        ]);
        setDayClicked(event.currentTarget.id);
    }

    function handleClickContinue(event) {
        event.preventDefault();
        navigate("/client");
    }

    if (!isLoaded) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#f6f6ee]">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#f6f6ee]">

            {/* Header de marca */}
            <MainTitle />

            {/* Resumen del pedido */}
            <div className="mt-4 mb-5">
                <ProductsResume items={items} />
            </div>

            {/* Separador */}
            <div className="flex items-center gap-3 px-4 mb-5">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">día de despacho</span>
                <div className="flex-1 h-px bg-gray-200" />
            </div>

            {/* Selector de días */}
            <div className="px-3 mb-6">
                <div className="flex gap-2 justify-center flex-wrap">
                    {instances.map((instance) => {
                        const isSelected = dayClicked == instance.id;
                        return (
                            <div
                                key={instance.id}
                                onClick={handleClickInstance}
                                id={instance.id}
                                dayname={instance.dayName}
                                daynumber={instance.dayNumber}
                                monthname={instance.monthName}
                                className={`
                                    rounded-2xl cursor-pointer transition-all duration-150 select-none
                                    ${isSelected
                                        ? "bg-[#2f5a2e] shadow-lg shadow-[#2f5a2e]/20 ring-2 ring-[#2f5a2e]"
                                        : "bg-white border border-gray-100 shadow-sm active:scale-95"
                                    }
                                `}
                                style={{ width: "88px" }}
                            >
                                {/* Sobreescribimos colores internos según selección */}
                                <div className={isSelected ? "text-white" : ""}>
                                    <div className="flex flex-col items-center py-3 px-2">
                                        <p className={`text-[11px] font-medium uppercase tracking-widest leading-none mb-1 ${isSelected ? "text-[#cde29a]" : "text-[#4a7c2f]"}`}>
                                            {instance.dayName}
                                        </p>
                                        <p className={`font-serif text-[28px] font-bold leading-none my-1 ${isSelected ? "text-white" : "text-[#1e2a1a]"}`}>
                                            {instance.dayNumber}
                                        </p>
                                        <p className={`text-[11px] font-medium uppercase tracking-wide leading-none ${isSelected ? "text-[#cde29a]" : "text-gray-400"}`}>
                                            {instance.monthName}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Botón continuar */}
            <div className="px-4 pb-8">
                <button
                    onClick={handleClickContinue}
                    disabled={deliveryDate.length === 0}
                    className={`
                        w-full py-3 rounded-xl text-sm font-semibold transition-all duration-150
                        ${deliveryDate.length === 0
                            ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                            : "bg-[#2f5a2e] hover:bg-[#3f7a3a] active:scale-[0.98] text-[#f4f3e6] shadow-md shadow-[#2f5a2e]/20"
                        }
                    `}
                >
                    {deliveryDate.length === 0 ? "Selecciona un día" : "Continuar →"}
                </button>
            </div>
        </div>
    );
};

export default DayForm;
